import React from 'react';

export const ImageObjectMicrodataSchema = ({image}) => {
  const containerProps = {
    itemScope: true,
    itemProp: 'primaryImageOfPage',
    itemType: "https://schema.org/ImageObject",
  }

  return (
    image ? <div {...containerProps}>
      <meta itemProp="url" content={image.url}/>
      <meta itemProp="width" content={image.width}/>
      <meta itemProp="height" content={image.height}/>
    </div> : null
  );
};